"use strict";
export const UngroupedGroupCopyCreator = (ungroupedGroupModel) => {
  return {
    groups: [
      {
        documents: ungroupedGroupModel.allDocuments(),
        name: "Ungrouped Documents",
        selected: true
      }
    ],
    groupSelected: () => {
    }
  };
};
